module.exports = __webpack_public_path__ + "img/product-5.e8a5188e.png";